import { render, staticRenderFns } from "./EditTaskDialog.vue?vue&type=template&id=52bb9cf1"
import script from "./EditTaskDialog.vue?vue&type=script&lang=js"
export * from "./EditTaskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports